import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AsyncTypeahead,Typeahead } from 'react-bootstrap-typeahead';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';

import { LBL_CLIENT, LBL_EVENT, LBL_TITLE, LBL_REVIEWED_BY, LBL_DATE_TO,LBL_RATING, LBL_SHIFT_DATE_FROM, LBL_STAR } from '../../../configs/labelConfigs';
import { CREW_MAX_RATING } from '../../../configs/staticConfigs'; 

import CustomMultiSelect from '../../../components/commons/helpers/customMultiSelect';

import { getUserGroupData } from '../../../utils/browserStorage';
import { filterClientsListAction } from '../../../actions/eventActions'; 
import { feedbackFilterEventsListAction,feedbackFilterReviewersListAction } from '../../../actions/filterActions'; 

import * as types from '../../../actions';

let starRatingData = []; // FOT MULTISELECT CONTROL 
CREW_MAX_RATING.forEach(item => {
    starRatingData.push({value:item,label:item+' '+LBL_STAR}); 
});

class FilterFeedback extends Component {
    
    constructor(props){
        super(props)
        this.state = { 
            
            clientListCalled: 0, 

            selectedClientId: this.props.clientId?this.props.clientId:0,   
            selectedClient: this.props.clientId?[{id:this.props.clientId, name:''}] : [],   
            clientsOptions: [],

            selectedEventId: 0, 
            selectedEvent: [], 
            eventsOptions: [], 

            selectedReviewerId: 0, 
            selectedReviewer: [], 
            reviewerOptions: [],


            starRatingIds: [],

            includeDate: false, 
            selectedStartDate: new Date(),
            selectedEndDate: new Date(),
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            dateValue:0
        }
    }

    handleClientChange = (selectedClient) => {
        let clId = 0; 
        let selClient = []; 
        if(selectedClient.length>0){
            selClient = selectedClient; 
            clId = selectedClient[0].id; 
            let dataObj = {clientsIds:[clId]}; 
            this.props.feedbackFilterEventsListAction(dataObj); 
            this.props.feedbackFilterReviewersListAction(dataObj); 
        } 
        this.setState({selectedClient:selClient, selectedClientId:clId});  
    }
    
    handleRemoveClient = (e) => { 
        console.log(e); 
        if(e==='') {
            console.log('IN IN IN'); 
            this.props.feedbackFilterEventsListAction(); 
            this.props.feedbackFilterReviewersListAction(); 
        } 
    }

    handleEventChange = (selectedEvent) => {
        let eventId = 0; 
        let selEvent = []; 
        if(selectedEvent.length>0){
            selEvent = selectedEvent; 
            eventId = selectedEvent[0].id; 
            let dataObj = {isEvent:1}; 
            if(this.props.clientId && this.props.clientId > 0) {
                let storageData = getUserGroupData('client'); 
                dataObj = {isEvent:1, affiliateIds:[Number(storageData.client_default_affiliate_id)],eventIds:[eventId]}; 
            }
            else {
                let arrClientIds = []
                if(this.state.selectedClient.length) {
                    this.state.selectedClient.forEach(item => {
                        arrClientIds.push(item.id)
                    }) 
                }

                if(arrClientIds.length) {
                    dataObj = {isEvent:1,clientsIds:arrClientIds,eventIds:[eventId]}; 
                }
                else {
                    dataObj = {isEvent:1,eventIds:[eventId]}; 
                }
            }

        } 
        this.setState({selectedEvent:selEvent, selectedEventId:eventId});  
    }
    
    handleRemoveEvent = (e) => {
        if(e==='') {
            if(this.props.clientId && this.props.clientId > 0) {
                let storageData = getUserGroupData('client'); 
                let dataObj = {isEvent:1, affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
                // this.props.feedbackFilterReviewersListAction(dataObj);
            }
            else {
                // let dataObj = {isEvent:1};
                // this.props.feedbackFilterReviewersListAction(dataObj); 
            }
            
        } 
    }

    handleReviewedbyChange = (selectedItem) => {
        let reviewerId = 0; 
        let selReviewer = []; 
        if(selectedItem.length>0){
            selReviewer = selectedItem; 
            reviewerId = selectedItem[0].id; 

            // let dataObj = {isEvent:1}; 
            // if(this.props.clientId && this.props.clientId > 0) {
            //     let storageData = getUserGroupData('client'); 
            //     dataObj = {isEvent:1, affiliateIds:[Number(storageData.client_default_affiliate_id)],reviewerIds:[reviewerId]}; 
            // }
            // else {
            //     let arrClientIds = []
            //     if(this.state.selectedClient.length) {
            //         this.state.selectedClient.forEach(item => {
            //             arrClientIds.push(item.id)
            //         }) 
            //     }

            //     if(arrClientIds.length) {
            //         dataObj = {isEvent:1,clientsIds:arrClientIds,reviewerIds:[reviewerId]}; 
            //     }
            //     else {
            //         dataObj = {isEvent:1,reviewerIds:[reviewerId]}; 
            //     }
            // }

        } 
        this.setState({selectedReviewer:selReviewer, selectedReviewerId:reviewerId});  
    }

    handleRemoveReviewedby = (e) => {
        if(e==='') {
            // if(this.props.clientId && this.props.clientId > 0) {
            //     let storageData = getUserGroupData('client'); 
            //     let dataObj = {isEvent:1, affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
            //     this.props.feedbackFilterReviewersListAction(dataObj);
            // }
            // else {
            //     let dataObj = {isEvent:1};
            //     this.props.feedbackFilterReviewersListAction(dataObj); 
            // }
            
        } 
    }

    onStarRatingDataChange = (selectedStatus) =>{
        let starRatingIds = [];
        selectedStatus.forEach((item) => {
            starRatingIds.push(parseInt(item.value,10));
        });
        this.setState({starRatingIds:starRatingIds});
    }


    onDateCheck = (e) => {
        this.setState({includeDate:!this.state.includeDate, dateValue:1-this.state.dateValue}) 
    }
    
    onStartDateChange = (date) =>{
        let startDate = new Date(date);
        
        if(this.state.selectedEndDate < startDate) {
            this.setState({selectedStartDate:startDate,selectedEndDate:startDate});    
        }
        else {
            this.setState({selectedStartDate:startDate});    
        }
    }

    onEndDateChange = (date) =>{ 
        let endDate = new Date(date);
        this.setState({selectedEndDate:endDate});  
    }

    resetFilters = () => { 
        starRatingData = []; // TO RESET MULTISEL VALUES

        this.setState({ 
            selectedClientId: 0,   
            selectedClient: [],   

            selectedEventId: 0, 
            selectedEvent: [], 

            selectedReviewerId: 0, 
            selectedReviewer: [], 

            includeDate: false, 
            selectedStartDate: new Date(),
            selectedEndDate: new Date(),
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            dateValue:0
        }); 

        // TO RESET MULTISEL VALUES 
        CREW_MAX_RATING.forEach(item => {
            starRatingData.push({value:item,label:item+' '+LBL_STAR}); 
        });
        
        if(this.props.clientId && this.props.clientId > 0) {
            let storageData = getUserGroupData('client'); 
            let dataObj = {isEvent:1, affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
            this.props.feedbackFilterEventsListAction(dataObj); 
            this.props.feedbackFilterReviewersListAction(dataObj);
        }
        else {
            this.props.filterClientsListAction(); 
            let dataObj = {isEvent:1}; 
            this.props.feedbackFilterEventsListAction(dataObj); 
            this.props.feedbackFilterReviewersListAction(dataObj);
        }
    }

    sendFilterData = () => {
        let filtersSelected = 0; 
        let arrClientIds = [];
        if(this.state.selectedClient && this.state.selectedClient.length) {
            this.state.selectedClient.forEach(item => {
                if(Number(item.id) > 0) { 
                    arrClientIds.push(item.id);
                    filtersSelected = 1; 
                }
            }) 
        }

        let arrEventIds = [];
        if(this.state.selectedEvent && this.state.selectedEvent.length) {
            this.state.selectedEvent.forEach(item => {
                if(Number(item.id) > 0) {
                    arrEventIds.push(item.id);
                    filtersSelected = 1; 
                }
            }) 
        }

        let arrStarRatingIds = []; 
        this.state.starRatingIds.forEach(item => { arrStarRatingIds.push(Number(item)); }); 
        if(arrStarRatingIds.length) filtersSelected = 1; 

        let fromDate = 0; 
        let endDate = 0;
        if(this.state.includeDate) {
            // let timeZone =  getUserTimeZone(window.location);
            fromDate = format(new Date(this.state.selectedStartDate), 'yyyy-MM-dd');
            endDate = format(new Date(this.state.selectedEndDate), 'yyyy-MM-dd');
            filtersSelected = 1;
        }
        
        let filterData = {clientsIds:arrClientIds, eventIds:arrEventIds, starRatingIds:arrStarRatingIds, selectedStartDate:fromDate, selectedEndDate:endDate, filtersSelected:filtersSelected}; 
        // this.props.applyFilters(filterData); 
    }

    componentDidUpdate (prevProps) {
        if(this.props.filterClicked!==prevProps.filterClicked && this.state.clientListCalled===0) {
            this.setState({clientListCalled:1}); // TO PREVENT REPEATED API CALLS 
            if(this.props.clientId && this.props.clientId > 0) {
                let storageData = getUserGroupData('client'); 
                let dataObj = {isEvent:1, affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
                this.props.feedbackFilterEventsListAction(dataObj); 
                this.props.feedbackFilterReviewersListAction(dataObj);
            }
            else {
                let dataObj = {isEvent:1}; 
                this.props.filterClientsListAction(); 
                this.props.feedbackFilterEventsListAction(dataObj); 
                this.props.feedbackFilterReviewersListAction(dataObj);
            }
        } 

        if(this.props.applyFilterClicked > 0 && this.props.applyFilterClicked!==prevProps.applyFilterClicked && this.state.applyFilterClicked < this.props.applyFilterClicked) {
            this.setState({applyFilterClicked:this.props.applyFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.sendFilterData(); 
        }

        if(this.props.resetFilterClicked > 0 && this.props.resetFilterClicked!==prevProps.resetFilterClicked && this.state.resetFilterClicked < this.props.resetFilterClicked) {
            this.setState({resetFilterClicked:this.props.resetFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.resetFilters(); 
        }

        const {filterClientsList,eventsFilterStatus,eventsFilterActivity,eventsFilterErrorData,filterFeedbackEventsList,filterActivity,filterStatus,filterErrorData,filterFeedbackStatus,filterFeedbackActivity, filterFeedbackErrorData, filterFeedbackReviewersList} = this.props; 
        

        if (filterActivity && filterActivity !== prevProps.filterActivity) {
            let arrTmp = [];
            arrTmp = (filterActivity && filterActivity.length) ? filterActivity.split('~~') : [];
            let actString = arrTmp[0]; 

            if(actString===types.FILTER_CLIENTS_LIST_SUCCESS) { 
                let clientsOptions = [];  
                if(filterStatus===200) {
                    if(filterClientsList && Array.isArray(filterClientsList)){
                        filterClientsList.forEach(item => {             
                            clientsOptions.push({id:item.client_id, name:item.client_name});
                        });            
                    }
                }
                else {
                    console.log('Clients List Error '+JSON.stringify(filterErrorData)); 
                }
                this.setState({clientsOptions}); 
            }
        }

        if (filterFeedbackActivity && filterFeedbackActivity !== prevProps.filterFeedbackActivity) {
            let arrTmp = [];
            arrTmp = (filterFeedbackActivity && filterFeedbackActivity.length) ? filterFeedbackActivity.split('~~') : [];
            let actString = arrTmp[0]; 

            let eventsOptions = [];  
            let reviewerOptions = [];  

            if(actString===types.FEEDBACK_FILTER_EVENTS_LIST_SUCCESS) { 
                if(filterFeedbackStatus===200) {
                    if(filterFeedbackEventsList && Array.isArray(filterFeedbackEventsList)){
                        filterFeedbackEventsList.forEach(item => {             
                            eventsOptions.push({id:item.event_id, name:item.event_title});
                        });            
                    }
                }
                else {
                    console.log('Projects List Error '+JSON.stringify(filterFeedbackErrorData)); 
                }
                this.setState({eventsOptions}); 
            }
            else if(actString===types.FEEDBACK_FILTER_EVENTS_LIST_ERROR) {
                console.log('Projects List Error '+JSON.stringify(filterFeedbackErrorData)); 
                this.setState({eventsOptions}); 
            }
            else if(actString===types.FEEDBACK_FILTER_REVIEWERS_LIST_SUCCESS) { 
                if(filterFeedbackStatus===200) {
                    if(filterFeedbackReviewersList && Array.isArray(filterFeedbackReviewersList)){
                        filterFeedbackReviewersList.forEach(item => {             
                            reviewerOptions.push({id:item.reviewer_id, name:item.reviewer_name});
                        });            
                    }
                }
                else {
                    console.log('Reviewer List Error '+JSON.stringify(filterFeedbackErrorData)); 
                }
                this.setState({reviewerOptions}); 
            }
            else if(actString===types.FEEDBACK_FILTER_REVIEWERS_LIST_ERROR) { 
                console.log('Reviewer List Error '+JSON.stringify(filterFeedbackErrorData)); 
                this.setState({reviewerOptions}); 
            }
        }
    }


    render(){

        let {selectedClient,clientsOptions, selectedEvent,eventsOptions, selectedReviewer,reviewerOptions, selectedStartDate, selectedEndDate, includeDate,dateValue} = this.state; 
            
        let paddingTopPix = 125; 
        return(
            <>
                {!this.props.isClientPage &&  
                <div className="filter-category">
                    <h4>{LBL_CLIENT}</h4>
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedClient}
                                id="clients"
                                labelKey="name"
                                options={clientsOptions}
                                placeholder="Choose Client..."
                                inputProps={{ name:'clientId', className:''}}
                                onChange={(s) => this.handleClientChange(s)}
                                onInputChange={this.handleRemoveClient}
                            />  
                        </div>
                    </div>
                </div>}

                <div className="filter-category">
                    <h4>{LBL_EVENT+' '+LBL_TITLE}</h4> 
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedEvent} 
                                id="events"
                                labelKey="name"
                                options={eventsOptions}
                                placeholder={"Choose "+' '+LBL_EVENT+"..."}
                                inputProps={{ name:'eventId', className:''}}
                                onChange={(s) => this.handleEventChange(s)}
                                onInputChange={this.handleRemoveEvent}
                            />  
                        </div>
                    </div>
                </div>

                <div className="filter-category">
                    <h4>{LBL_REVIEWED_BY}</h4> 
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedReviewer}  
                                id="reviewdby"
                                labelKey="name"
                                options={reviewerOptions} 
                                placeholder="Choose Reviewd by..."
                                inputProps={{ name:'reviewerId', className:''}}
                                onChange={(s) => this.handleReviewedbyChange(s)}
                                onInputChange={this.handleRemoveReviewedby}
                            />  
                        </div>
                    </div>
                </div>

                <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_RATING}</h4>
                        <div className="form-group multisel_textbox">
                            <div className="form-group select-input skills" >
                                <CustomMultiSelect data={starRatingData}  onChange={selected =>this.onStarRatingDataChange(selected)} isTextBox={false}  needSelectAll={true} />
                            </div>
                        </div>
                    </div> 
                </div>  
                
                <div className="filter-category">                   
                    <div className="row"> 
                        <div className="col-6"> <h4>
                        <div className="custom-checkbox"> 
                                <input type="checkbox" id="includeDate" name="includeDate"  checked={includeDate} value={dateValue} onChange={e => this.onDateCheck(e)} />
                                <label className="checkbox" htmlFor="includeDate" ></label>
                                <label htmlFor="includeDate" > &nbsp; {LBL_SHIFT_DATE_FROM} </label> 
                            </div></h4>
                        </div>
                        <div className="col-6"> <h4>{LBL_DATE_TO}</h4></div>
                    </div>
                    <div className="form-group">
                        <div className="form-group"> 
                            <div className="row">
                                <div className="col-6">
                                    <div className="calendar-input">  
                                        <DatePicker 
                                            selected={selectedStartDate}
                                            onChange={selected => this.onStartDateChange(selected)}
                                            name="startDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select"
                                            //maxDate={new Date()}
                                            // minDate={new Date()}
                                            fixedHeight   
                                            disabled={!includeDate}       
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="calendar-input ">  
                                        <DatePicker 
                                            selected={selectedEndDate}
                                            onChange={selected => this.onEndDateChange(selected)}
                                            name="endDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select"
                                            //maxDate={new Date()}
                                            minDate={new Date(selectedStartDate)}
                                            fixedHeight     
                                            disabled={!includeDate}         
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div style={{paddingTop:paddingTopPix}}></div>

            </>
        )
    }

}

const mapStateToProps = (state) => { 
    return {
        filterClientsList: state.event.filterClientsList, 
        filterStatus: state.event.filterStatus,
        filterActivity: state.event.filterActivity,
        filterErrorData: state.event.filterErrorData,

        filterFeedbackStatus: state.filterItems.filterFeedbackStatus,
        filterFeedbackActivity: state.filterItems.filterFeedbackActivity,
        filterFeedbackEventsList: state.filterItems.filterFeedbackEventsList, 
        filterFeedbackErrorData: state.filterItems.filterFeedbackErrorData,

        filterFeedbackReviewersList: state.filterItems.filterFeedbackReviewersList,
        
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        filterClientsListAction:filterClientsListAction, 
        feedbackFilterEventsListAction:feedbackFilterEventsListAction,
        feedbackFilterReviewersListAction:feedbackFilterReviewersListAction
    },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(FilterFeedback);
